export const CUSTOM_LINK_SLICE = 'CUSTOM_LINK_SLICE';

export const HEADER_TAGS = {
    USER_SESSION_ID: 'USER_SESSION_ID',
};

export enum ECustomLinkModalTableColumnType {
    TEXT = 'TEXT',
    LINK = 'LINK',
    FILE_WITH_TOKEN = 'FILE_WITH_TOKEN',
    CUSTOM_URL = 'CUSTOM_URL',
}
